import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { Home, LendingPool, Risks, Claim, Account, Bounty } from './views';

export interface AppRoute {
    value: string;
    to: string;
}

export const HomeRoute = {
    value: 'Markets',
    to: '/',
} as AppRoute;

export const LendingPoolRoute = {
    value: 'LendingPool',
    to: '/lending-pool/:factory/:pairAddress',
} as AppRoute;

export const AccountRoute = {
    value: 'AccountRoute',
    to: '/account/:account',
} as AppRoute;

export const BountyRoute = {
    value: 'Bounty',
    to: '/bounty',
} as AppRoute;

export const CreateNewPairRoute = {
    value: 'Create New Pair',
    to: '/create-new-pair',
} as AppRoute;

export const RisksRoute = {
    value: 'Risks',
    to: '/risks',
} as AppRoute;

export const ClaimRoute = {
    value: 'Claim',
    to: '/claim',
} as AppRoute;

export const UserGuideRoute = {
    value: 'User Guide',
    to: '/user-guide',
} as AppRoute;

export const DocsRoute = {
    value: 'Docs',
    to: '/docs',
} as AppRoute;

export const LiteRoute = {
    value: 'Lite',
    to: '/lite',
} as AppRoute;

export const BridgeRoute = {
    value: 'Bridge IMX',
    to: '/celer-bridge',
} as AppRoute;

export enum AppRoutes {
    HomeRoute,
    LendingPoolRoute,
    CreateNewPairRoute,
    RisksRoute,
    ClaimRoute,
    UserGuideRoute,
    DocsRoute,
    AccountRoute,
    BountyRoute,
    BridgeRoute,
}

/**
 * Generates the application routing structure.
 */
export default function Routing() {
    return (
        <div className="routing">
            <Router>
                <Switch>
                    <Route path={HomeRoute.to} exact>
                        <Home />
                    </Route>
                    {/*<Route path={CreateNewPairRoute.to}>
              <CreateNewPair />
  </Route>*/}
                    <Route path={LendingPoolRoute.to}>
                        <LendingPool />
                    </Route>
                    <Route path={AccountRoute.to}>
                        <Account />
                    </Route>
                    <Route path={BountyRoute.to}>
                        <Bounty />
                    </Route>
                    <Route path={ClaimRoute.to}>
                        <Claim />
                    </Route>
                    <Route path={RisksRoute.to}>
                        <Risks />
                    </Route>
                    <Route
                        path={UserGuideRoute.to}
                        component={(): any => {
                            window.location.href = 'https://impermax.finance/User-Guide-Impermax.pdf';
                            return null;
                        }}
                    />
                    <Route
                        path={DocsRoute.to}
                        component={(): any => {
                            window.location.href = 'https://docs.impermax.finance/';
                            return null;
                        }}
                    />
                    <Route
                        path={BridgeRoute.to}
                        component={(): any => {
                            window.location.href = 'https://cbridge.celer.network/#/transfer';
                            return null;
                        }}
                    />
                    <Route
                        path={LiteRoute.to}
                        component={(): any => {
                            window.location.href = 'https://lite.impermax.finance';
                            return null;
                        }}
                    />
                </Switch>
            </Router>
        </div>
    );
}
